var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { ImxPendingBurnStatus, } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { checkIfWalletAsEnoughCurrency } from '../../utils/balances';
import { useAccountBillingInformation } from '../account/use-account-billing-information';
import { useCtaTokenRates } from '../cta-token/use-cta-token-rates';
import { useImxActions } from '../imx/use-imx-actions';
export var CTA_TOKEN_SHOP_DISCOUNT = 5;
export var SKU_PREFIX = 'TCG_';
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CTA_TOKEN"] = "CTA_TOKEN";
    PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethod["MIXPAY"] = "MIXPAY";
})(PaymentMethod || (PaymentMethod = {}));
export function useShopSerie(id) {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var _a = useContext(UserContext), user = _a.user, balances = _a.balances, selectedWallet = _a.selectedWallet, localWalletAddress = _a.localWalletAddress;
    var parseCurrencyQuantity = useContext(CurrencyContext).parseCurrencyQuantity;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _b = useCtaTokenRates(), ctaTokenUsdRate = _b.ctaTokenUsdRate, timestamp = _b.timestamp;
    var showUpdateBillingInformationDialog = useAccountBillingInformation().showUpdateBillingInformationDialog;
    var imxActions = useImxActions();
    var _c = useState(undefined), serie = _c[0], setSerie = _c[1];
    var _d = useState(undefined), perks = _d[0], setPerks = _d[1];
    var _e = useState(0), selectedChestIndex = _e[0], setSelectedChestIndex = _e[1];
    var _f = useState(1), quantity = _f[0], setQuantity = _f[1];
    var _g = useState(PaymentMethod.CTA_TOKEN), paymentMethod = _g[0], setPaymentMethod = _g[1];
    var _h = useState(undefined), ctaTokenAmount = _h[0], setCtaTokenAmout = _h[1];
    useEffect(function () {
        setPaymentMethod((user === null || user === void 0 ? void 0 : user.mpcWalletAddress) === undefined ? PaymentMethod.CREDIT_CARD : PaymentMethod.CTA_TOKEN);
    }, [user]);
    useEffect(function () {
        function getSerie() {
            return __awaiter(this, void 0, void 0, function () {
                var serie, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            serie = gqlSdk.CardChestGetSerieUserState({ input: { serie: id } });
                            _a = setSerie;
                            return [4 /*yield*/, serie];
                        case 1:
                            _a.apply(void 0, [(_b.sent()).cardChestGetSerieUserState]);
                            return [2 /*return*/];
                    }
                });
            });
        }
        function getPerks() {
            return __awaiter(this, void 0, void 0, function () {
                var perksResponse;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress))
                                return [2 /*return*/];
                            return [4 /*yield*/, gqlSdk.UserGetLoyaltyState()];
                        case 1:
                            perksResponse = _a.sent();
                            setPerks(perksResponse.userGetLoyaltyState);
                            return [2 /*return*/];
                    }
                });
            });
        }
        getSerie();
        getPerks();
    }, [user, id]);
    useEffect(function () {
        var _a;
        var usdPrice = (_a = serie === null || serie === void 0 ? void 0 : serie.cardChestFindManyPreview[selectedChestIndex]) === null || _a === void 0 ? void 0 : _a.usdPrice;
        if (!usdPrice || !ctaTokenUsdRate || !perks) {
            setCtaTokenAmout(undefined);
            return;
        }
        var ctaTokenAmount = (usdPrice * quantity * (1 - (perks.perks.global.shopDiscount + CTA_TOKEN_SHOP_DISCOUNT) / 100)) / ctaTokenUsdRate;
        var ctaTokenAmountWithoutDiscount = (usdPrice * quantity) / ctaTokenUsdRate;
        var hasEnoughCurrency = checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, appEnv.ctaTokenAddress, "".concat(Math.floor(ctaTokenAmount * 10000), "00000000000000"));
        setCtaTokenAmout({
            value: ctaTokenAmount.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 4,
            }),
            withoutDiscountValue: ctaTokenAmountWithoutDiscount.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 4,
            }),
            hasEnoughCurrency: hasEnoughCurrency,
        });
    }, [user, balances, selectedWallet, localWalletAddress, perks, selectedChestIndex, serie, ctaTokenUsdRate, quantity]);
    function buy() {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = paymentMethod;
                        switch (_a) {
                            case PaymentMethod.CTA_TOKEN: return [3 /*break*/, 1];
                            case PaymentMethod.CREDIT_CARD: return [3 /*break*/, 2];
                            case PaymentMethod.MIXPAY: return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 1:
                        {
                            showBuyWithCtaTokenConfirmDialog();
                            return [3 /*break*/, 7];
                        }
                        _b.label = 2;
                    case 2: return [4 /*yield*/, buyWithStripe()];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 4: return [4 /*yield*/, buyWithMixPay()];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        {
                            throw new Error("Invalid payment method: ".concat(paymentMethod));
                        }
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    function showBuyWithCtaTokenConfirmDialog() {
        if (!ctaTokenAmount)
            return;
        setDialogProps((user === null || user === void 0 ? void 0 : user.billingAddressCountry)
            ? {
                common: {
                    title: t('common.buy-pack'),
                    close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                    actions: [{ highlighted: true, text: t('common.confirm'), action: buyWithCtaToken }],
                },
                custom: {
                    type: DialogType.SHOP_BUY,
                    price: ctaTokenAmount.value,
                },
            }
            : {
                common: {
                    title: t('common.missing-information'),
                    close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                    actions: [{ highlighted: true, text: t('common.manage'), action: showUpdateBillingInformationDialog }],
                },
                custom: {
                    type: DialogType.SIMPLE,
                    message: t('common.billing-address-required'),
                },
            });
    }
    function buyWithCtaToken() {
        return __awaiter(this, void 0, void 0, function () {
            var itemSku, error, response, pendingCtaTokenTransfer, transferCompleted, transferResult, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        itemSku = "".concat(SKU_PREFIX).concat((_a = serie === null || serie === void 0 ? void 0 : serie.cardChestFindManyPreview[selectedChestIndex]) === null || _a === void 0 ? void 0 : _a.name);
                        setServerLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 10, , 11]);
                        return [4 /*yield*/, gqlSdk.ShopBuy({ input: { sku: itemSku, amount: quantity, timestamp: timestamp } })];
                    case 2:
                        response = _b.sent();
                        pendingCtaTokenTransfer = response.shopBuy.pendingCtaTokenTransfer;
                        return [4 /*yield*/, imxActions.transferERC20({
                                walletFrom: selectedWallet,
                                toAddress: pendingCtaTokenTransfer.recipientWalletAddress,
                                tokenAddress: appEnv.ctaTokenAddress,
                                quantity: "".concat(pendingCtaTokenTransfer.ctaTokenCountToTransferDeci18.toString(), "00000000"),
                            })];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTtokenTransferSetDone({
                                input: { pendingCtaTokenTransferUuid: pendingCtaTokenTransfer.uuid },
                            })];
                    case 4:
                        _b.sent();
                        transferCompleted = false;
                        _b.label = 5;
                    case 5: return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTtokenTransferFindOne({
                            input: { pendingCtaTokenTransferUuid: pendingCtaTokenTransfer.uuid },
                        })];
                    case 6:
                        transferResult = _b.sent();
                        transferCompleted =
                            transferResult.blockchainPendingCtaTtokenTransferFindOne.status === ImxPendingBurnStatus.COMPLETED;
                        if (!!transferCompleted) return [3 /*break*/, 8];
                        return [4 /*yield*/, sleep(1000)];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8:
                        if (!transferCompleted) return [3 /*break*/, 5];
                        _b.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        err_1 = _b.sent();
                        if (err_1 instanceof Error) {
                            error = t('error.generic');
                            console.log("[buyWithCtaToken] ".concat(err_1));
                        }
                        return [3 /*break*/, 11];
                    case 11:
                        setServerLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.buy-pack'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('buy-pack.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function buyWithStripe() {
        return __awaiter(this, void 0, void 0, function () {
            var itemSku, error, response, order, passed, respone, err_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        itemSku = "".concat(SKU_PREFIX).concat((_a = serie === null || serie === void 0 ? void 0 : serie.cardChestFindManyPreview[selectedChestIndex]) === null || _a === void 0 ? void 0 : _a.name);
                        setServerLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 9, , 10]);
                        return [4 /*yield*/, gqlSdk.PaymentCreateStripeOrder({
                                input: { itemSku: itemSku, quantity: quantity },
                            })];
                    case 2:
                        response = _b.sent();
                        order = response.paymentCreateStripeOrder;
                        window.open(order.buyUrl, '_blank');
                        passed = false;
                        _b.label = 3;
                    case 3: return [4 /*yield*/, gqlSdk.PaymentOrderStatus({
                            input: { orderUuid: order.orderUuid },
                        })];
                    case 4:
                        respone = _b.sent();
                        passed = respone.paymentOrderStatus.passed;
                        if (!!passed) return [3 /*break*/, 6];
                        return [4 /*yield*/, sleep(2000)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        if (passed === false) return [3 /*break*/, 3];
                        _b.label = 7;
                    case 7: return [4 /*yield*/, sleep(1000)];
                    case 8:
                        _b.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        err_2 = _b.sent();
                        if (err_2 instanceof Error) {
                            error = t('error.generic');
                            console.log("[buyWithStripe] ".concat(err_2));
                        }
                        return [3 /*break*/, 10];
                    case 10:
                        setServerLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.buy-pack'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('buy-pack.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function buyWithMixPay() {
        return __awaiter(this, void 0, void 0, function () {
            var itemSku, error, response, order, passed, respone, err_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        itemSku = "".concat(SKU_PREFIX).concat((_a = serie === null || serie === void 0 ? void 0 : serie.cardChestFindManyPreview[selectedChestIndex]) === null || _a === void 0 ? void 0 : _a.name);
                        setServerLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 9, , 10]);
                        return [4 /*yield*/, gqlSdk.PaymentCreateMixPayOrder({
                                input: { itemSku: itemSku, quantity: quantity },
                            })];
                    case 2:
                        response = _b.sent();
                        order = response.paymentCreateMixPayOrder;
                        window.open(order.buyUrl, '_blank');
                        passed = false;
                        _b.label = 3;
                    case 3: return [4 /*yield*/, gqlSdk.PaymentOrderStatus({
                            input: { orderUuid: order.orderUuid },
                        })];
                    case 4:
                        respone = _b.sent();
                        passed = respone.paymentOrderStatus.passed;
                        if (!!passed) return [3 /*break*/, 6];
                        return [4 /*yield*/, sleep(2000)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        if (passed === false) return [3 /*break*/, 3];
                        _b.label = 7;
                    case 7: return [4 /*yield*/, sleep(1000)];
                    case 8:
                        _b.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        err_3 = _b.sent();
                        if (err_3 instanceof Error) {
                            error = t('error.generic');
                            console.log("[buyWithMixPay] ".concat(err_3));
                        }
                        return [3 /*break*/, 10];
                    case 10:
                        setServerLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.buy-pack'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('buy-pack.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        serie: serie,
        perks: perks,
        selectedChestIndex: selectedChestIndex,
        setSelectedChestIndex: setSelectedChestIndex,
        quantity: quantity,
        ctaTokenAmount: ctaTokenAmount,
        setQuantity: setQuantity,
        paymentMethod: paymentMethod,
        setPaymentMethod: setPaymentMethod,
        buy: buy,
    };
}
